import { QuotaTypeEnum } from '@/components/Passenger/models/TransportationPermission';
import Vue from 'vue';

Vue.filter('quotaAmount', (quota: number, quotaType: number, currencySymbol: string, isMileageInstance: boolean) => {
    switch(quotaType as QuotaTypeEnum) {
        case QuotaTypeEnum.Distance:
            return isMileageInstance ? quota / 1609.34 + ' mi' : quota / 1000 + ' km';
        case QuotaTypeEnum.Currency:
            return quota / 100 + currencySymbol;
        default:
            return quota + Vue.i18n.translate('transportationPermission.pcs');
    }
  });

  Vue.filter('quotaConvert', (quota: number, quotaType: number, isMileageInstance: boolean) => {
    switch(quotaType as QuotaTypeEnum) {
        case QuotaTypeEnum.Distance:
            return isMileageInstance ? quota / 1609.34 : quota / 1000;
        case QuotaTypeEnum.Currency:
            return quota / 100;
        default:
            return quota;
    }
  });